/* eslint-disable quotes,space-before-function-paren */

/**
 * Browser
 */
class Browser {
  static OPERA = 'opera';
  static FIREFOX = 'firefox';
  static SAFARI = 'safari';
  static INTERNET_EXPLORER = 'internet_explorer';
  static EDGE = 'edge';
  static CHROME = 'chrome';
  static BLINK = 'blink';

  static BROWSERS = [
    this.OPERA,
    this.FIREFOX,
    this.SAFARI,
    this.INTERNET_EXPLORER,
    this.EDGE,
    this.CHROME,
    this.BLINK,
  ];

  /**
   * Check if the current browser matches the given browser.
   * Inspired by https://stackoverflow.com/a/9851769
   *
   * @param {string} browserName
   * @returns {boolean}
   */
  static is(browserName) {
    switch (browserName) {
      // Opera 8.0+
      case this.OPERA:
        return (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
      // Firefox 1.0+
      case this.FIREFOX:
        return typeof InstallTrigger !== 'undefined';
      // Safari 3.0+ "[object HTMLElementConstructor]"
      case this.SAFARI:
        return /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
      // Internet Explorer 6-11
      case this.INTERNET_EXPLORER:
        return /*@cc_on!@*/false || !!document.documentMode;
      // Edge 20+
      case this.EDGE:
        return !this.isIE() && !!window.StyleMedia;
      // Chrome 1 - 71
      case this.CHROME:
        return !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
      // Blink engine detection
      case this.BLINK:
        return (this.isChrome() || this.isOpera()) && !!window.CSS;
      default:
        throw new Error('Unknown browser name');
    }
  }

  /**
   * Get current browser.
   *
   * @returns {string}
   */
  static getBrowser() {
    for (const browser of this.BROWSERS) {
      if (this.is(browser)) {
        return browser;
      }
    }
    return 'Unknown Browser';
  }

  /**
   * @returns {boolean}
   */
  static isOpera() {
    return this.is(this.OPERA);
  }

  /**
   * @returns {boolean}
   */
  static isFirefox() {
    return this.is(this.FIREFOX);
  }

  /**
   * @returns {boolean}
   */
  static isSafari() {
    return this.is(this.SAFARI);
  }

  /**
   * @returns {boolean}
   */
  static isIE() {
    return this.is(this.INTERNET_EXPLORER);
  }

  /**
   * @returns {boolean}
   */
  static isEdge() {
    return this.is(this.EDGE);
  }

  /**
   * @returns {boolean}
   */
  static isChrome() {
    return this.is(this.CHROME);
  }

  /**
   * @returns {boolean}
   */
  static isBlink() {
    return this.is(this.BLINK);
  }
}

export default Browser;
